import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const FacebookBanner = ({ event, textColor, bgColor, titleFontSize, speakerFontSize }) => {
  const titleStyle = titleFontSize ? { fontSize: `${titleFontSize}px` } : undefined;
  const speakerStyle = speakerFontSize ? { fontSize: `${speakerFontSize}px` } : undefined;
  return (
    <div className={styles.fbBanner} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
      <div className={styles.fbTextContainer}>
        <span className={styles.fbLabel}>Meetup #{event.eventMeetupNo}</span>
        <span className={styles.fbTitle} style={titleStyle}>{event.eventName}</span>
      </div>
      <div className={styles.fbLogo}>
        <ScaledLogo color={event.color} width={384} height={442} />
      </div>
      <div className={styles.fbSpeakers}>
        {event.speakers?.map((speaker, i) => (
          <div key={i} className={styles.fbSpeakerCol}>
            <p className={styles.fbSpeakerName} style={speakerStyle}>{speaker.name}</p>
            <p className={styles.fbSpeakerDetail} style={speakerStyle}>{speaker.title}</p>
            <p className={styles.fbSpeakerDetail} style={speakerStyle}>{speaker.businessName}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacebookBanner;
